<div class="dialog-wrapper">
  <p>{{text | translate}}</p>
</div>
